module.exports = __webpack_public_path__ + "static/06-thumb-fa7980933e29f8202fb5345a14afa10a.jpg";